import { createStyles, rem } from "@mantine/core";

export const useFooterStyles = createStyles((theme) => ({}));
